/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * SEA-Router
 * Service redirects SEM-URLs.
 * OpenAPI spec version: v0.0.1
 */
import { adapter } from './adapter';
/**
 * content returns special SEA content
 */
export interface Content {
  headlinePrefix?: string;
  subline?: string;
  image: string;
}

/**
 * list of available presets
 */
export type Presets = Preset[];

/**
 * content returns the available preset values
 */
export interface Preset {
  label: string;
  slug: string;
}

export type ErrorResponse = {
  /** Error code */
  code: number;
  /** Error message */
  message: string;
};

/**
 * content response schema
 */
export type ContentResponse = Content;

/**
 * success
 */
export type PresetsResponse = Presets;

/**
 * split.io query parameter
 */
export type SplitParamsParameter = string[];

/**
 * set true if you want to know the redirect URL instead of being redirected instantly
 */
export type WantUrlParamParameter = boolean;

export type RedirectParams = {
/**
 * split.io query parameter
 */
s?: SplitParamsParameter;
/**
 * set true if you want to know the redirect URL instead of being redirected instantly
 */
wantUrl?: WantUrlParamParameter;
};

/**
 * Keyword routing to special IBE parameters.
 */
export type redirectResponse200 = {
  data: void
  status: 200
}

export type redirectResponse302 = {
  data: void
  status: 302
}

export type redirectResponse404 = {
  data: ErrorResponse
  status: 404
}
    
export type redirectResponseComposite = redirectResponse200 | redirectResponse302 | redirectResponse404;
    
export type redirectResponse = redirectResponseComposite & {
  headers: Headers;
}

export const getRedirectUrl = (keywordId: string,
    slug: string,
    params?: RedirectParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sea/${keywordId}/${slug}?${stringifiedParams}` : `/sea/${keywordId}/${slug}`
}

export const redirect = async (keywordId: string,
    slug: string,
    params?: RedirectParams, options?: RequestInit): Promise<redirectResponse> => {
  
  return adapter<redirectResponse>(getRedirectUrl(keywordId,slug,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Returns the SEA content for a given code.
 */
export type contentResponse200 = {
  data: ContentResponse
  status: 200
}
    
export type contentResponseComposite = contentResponse200;
    
export type contentResponse = contentResponseComposite & {
  headers: Headers;
}

export const getContentUrl = (keywordId: string,
    slug: string,) => {


  

  return `/content/${keywordId}/${slug}`
}

export const content = async (keywordId: string,
    slug: string, options?: RequestInit): Promise<contentResponse> => {
  
  return adapter<contentResponse>(getContentUrl(keywordId,slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * Returns the available SEA presets.
 */
export type presetsResponse200 = {
  data: PresetsResponse
  status: 200
}
    
export type presetsResponseComposite = presetsResponse200;
    
export type presetsResponse = presetsResponseComposite & {
  headers: Headers;
}

export const getPresetsUrl = () => {


  

  return `/presets`
}

export const presets = async ( options?: RequestInit): Promise<presetsResponse> => {
  
  return adapter<presetsResponse>(getPresetsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
